var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',[_c('div',{staticClass:"min-vh-100 d-flex"},[_c('main',{staticClass:"container-fluid py-2"},[_vm._t("default")],2)]),_c('Player',{attrs:{"share":""}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }